import { Injectable, Injector } from '@angular/core';
import { GamesService, HttpDataService } from '../../core';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class LicenseCloneService extends HttpDataService {
  public LMS_AUTH_TOKEN_GAMES = '0b98484b09bdeb59812f613dacf8852ca1a4dbea';
  // public LMS_AUTH_TOKEN_GAMES = 'tokenglc';

  constructor(protected injector: Injector, public gamesService: GamesService) {
    super(injector, '/');
  }

  cloneLicense(license) {
    const indexCurrentSublicenseId = license.isSuperlicense
      ? license.sublicenses.findIndex((x) => x == license.currentSublicenseId)
      : -1;
    const gameId = license.isSuperlicense ? license.modules[indexCurrentSublicenseId].gameId : license.gameId;
    const licenseId = license.currentSublicenseId ? license.currentSublicenseId : license.id;
    const gameProcedureMap = {
      triskelion: (game) => {
        this.cloneTriskelion(license, game);
      },
      pacific: (game) => {
        const urlBack = [game.backendHost, 'ws-admin', 'clone-player'].join('/');
        this.getTokenPacific(licenseId, urlBack);
      },
      '2100': (game) => {
        const urlBack = [game.backendHost, 'player/clone'].join('/');
        const urlFront = game.loginUrl;
        this.getTokenGame(licenseId, urlBack, urlFront);
      },
      merchants: (game) => {
        const urlBack = [game.backendHost, 'api/player/clone'].join('/');
        const urlFront = game.loginUrl;
        this.getTokenGame(licenseId, urlBack, urlFront);
      },
      ada: (game) => {
        const urlBack = [game.backendHost, 'player/clone'].join('/');
        const urlFront = game.loginUrl;
        this.getTokenGame(licenseId, urlBack, urlFront);
      },
      ada_gdpr: (game) => {
        const urlBack = [game.backendHost, 'player/clone'].join('/');
        const urlFront = game.loginUrl;
        this.getTokenGame(licenseId, urlBack, urlFront);
      },
      triskelion_2018: (game) => {
        const urlBack = [game.backendHost, 'games-core/clone'].join('/');
        const urlFront = game.loginUrl;
        this.getTokenGame(licenseId, urlBack, urlFront);
      },
      default: (game) => {
        const urlBack = [game.backendHost, 'player/clone'].join('/');
        const urlFront = game.loginUrl;
        this.getTokenGame(licenseId, urlBack, urlFront);
      }
    };

    this.gamesService.getGame(gameId).subscribe({
      next: (game) => {
        const procedure = gameProcedureMap[game.canonicName] || gameProcedureMap['default'];
        procedure(game);
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  getTokenGame(licenseId: string, urlBack: string, urlFront: string): Promise<any> {
    const token = ['authToken', this.LMS_AUTH_TOKEN_GAMES].join('=');
    const tokenUrl = [[urlBack, licenseId].join('/'), token].join('?');
    return lastValueFrom(this.http.post<any>(tokenUrl, this.getRequestOptions()))
      .then((response) => {
        const myresponse = response;
        const url = [urlFront, myresponse.token].join('?t=');
        window.open(url, '_blank');
      })
      .catch((error) => this.handlePromiseError(error));
  }

  getTokenPacific(licenseId: string, urlBack: string) {
    const token = ['authToken', this.LMS_AUTH_TOKEN_GAMES].join('=');
    const url = [[urlBack, licenseId].join('/'), token].join('?');
    window.open(url, '_blank');
  }

  cloneTriskelion(license, game) {
    let newWin;
    newWin = window.open();
    newWin.focus();
    this.createLoginFormTKS(newWin.document, game, license).then((data) => {
      data.submitForm();
    });
  }

  getIntLicenseID(licenseId: string, game): Promise<any> {
    const url = `${game.backendHost}/getIntLicenseId/${licenseId}`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }

  createLoginFormTKS(doc, game, formData) {
    return this.getIntLicenseID(formData.currentSublicenseId ? formData.currentSublicenseId : formData.id, game).then(
      (data) => {
        const licenseInt = data.intLicenseId;
        const form = document.createElement('form');
        const autocloneInput = document.createElement('input');
        const licenseInput = document.createElement('input');
        const userInput = document.createElement('input');
        const tokenInput = document.createElement('input');

        form.setAttribute('action', game.loginUrl);
        form.setAttribute('method', 'post');

        userInput.setAttribute('type', 'hidden');
        autocloneInput.setAttribute('type', 'hidden');
        licenseInput.setAttribute('type', 'hidden');
        tokenInput.setAttribute('type', 'hidden');

        autocloneInput.setAttribute('name', 'autoclone');
        autocloneInput.setAttribute('value', '1');
        userInput.setAttribute('name', 'user_name');
        userInput.setAttribute('value', licenseInt.toString());
        licenseInput.setAttribute('name', 'licenseid');
        licenseInput.setAttribute('value', licenseInt.toString());
        tokenInput.setAttribute('name', 'authtoken');
        tokenInput.setAttribute('value', 'TRISKELIONAUTHTOKEN');

        form.appendChild(autocloneInput);
        form.appendChild(licenseInput);
        form.appendChild(tokenInput);
        doc.body.appendChild(form);

        return {
          submitForm: function () {
            form.submit();
          }
        };
      }
    );
  }
}
